/**
 * 管理番号の採番。
 * 体系: オペレーター管理番号 OP-xxxx / 会社 CL-xxx
 * (BB ID・内線番号は masters/bbNumbering.ts。登録済み番号の続きから採番するため counters は使わない)
 *
 * counters/{key} を Firestore トランザクションでインクリメントするため、
 * 同時登録でも番号は重複しない。
 */
import { doc, runTransaction } from 'firebase/firestore';
import { getDb } from './firebase';

function pad(n: number, width: number): string {
  return String(n).padStart(width, '0');
}

/** オペレーター管理番号(OP-0001。システム自動付与) */
export async function nextOperatorCode(): Promise<string> {
  return `OP-${pad(await nextSequence('OP'), 4)}`;
}

/** 会社ID(CL-001。仕様書 §4.2 の例に合わせて3桁) */
export async function nextCompanyCode(): Promise<string> {
  return `CL-${pad(await nextSequence('CL'), 3)}`;
}

async function nextSequence(key: string): Promise<number> {
  const ref = doc(getDb(), 'counters', key);
  return runTransaction(getDb(), async (tx) => {
    const snap = await tx.get(ref);
    const next = ((snap.data()?.value as number | undefined) ?? 0) + 1;
    tx.set(ref, { value: next }, { merge: true });
    return next;
  });
}
